import {HttpParams} from '@angular/common/http';

/**
 * constructs the parameters for the http request
 *
 * @param params concatenated parameters
 * @returns complete parameter list
 */
export const getParams = (parameterName: string, language: string, additionalParams?: string) => {
    let params = "'fs_language':'" + language + "'";

    if (additionalParams !== undefined) {
        params = `{${params},${additionalParams}}`;
    } else {
        params = `{${params}}`;
    }

    return new HttpParams().set(parameterName, params);
};

/**
 * resolves the language
 *
 * @returns language as a parameter
 */
export const getLanguageParam = () => "'fs_language':{'$in':['XX_XX','EN_US']}";

export const getLanguageParamAvars = () => "'fs_language':'XX_XX'";
